export const messages = {

  alerts: {
    subscribe: {
      cashbacker_no_action: "Grattis!! Du är redan medlem i min kundklubb och har ett konto på Cashbacker.se."
    }
  },
  errors: {
    "UNIQUENESS_VIOLATION": "Duplicate",
    "EMAIL_TAKEN": "Email taken"
  },

  loginScreen: {
    emailField: "Email",
    passwordField: "Lösenord",
    loginButton: "Log in"
  },
  navigation: {
    logout: "Logga ut"
  },

  resources: {
    users: {
      name: "Användare"
    },
    admins: {
      name: "Administratörer",
      titleCreate: "Skapa administratör",
      titleEdit: "Administratör",
      inputs: {
        email: "e-post",
        password: "Lösenord",
        repeatPassword: "Upprepa lösenordet",
        phoneNumber: "Telefonnummer",
      },
      fields: {
        email: "e-post",
        phoneNumber: "Telefonnummer",
        createdAt: "Skapad vid",
        updatedAt: "Uppdaterad vid",
      },
      validation: {
        email: "E-post är obligatoriskt",
        phone: "Telefon numret ej korrekt",
        phoneRequired: "Telefonnummer är obligatoriskt",
        password: "Lösenord är obligatoriskt",
        repeatPassword: "Upprepa lösenordet är obligatoriskt",
        matchPasswords: "Lösenorden matchar inte",
      }
    },
    storeOwners: {
      name: "Butiksägarna ",
      titleEdit: "Butiksägare",
      titleCreate: "Skapa butiksägare",
      search: "Sök butiksägare efter förnamn",
      filter_last_name: "Sök butiksägare efter efternamn",
      fields: {
        storeOwner: "butiksägare",
        email: "e-post",
        companyName: "företagsnamn",
        companyAddress: "företagsadress",
        active: "aktiva"
      },
      inputs: {
        firstName: "Förnamn",
        lastName: "Efternamn",
        email: "E-post",
        password: "Lösenord",
        repeatPassword: "Upprepa lösenordet",
        companyName: "Företagsnamn",
        companyNumber: "Företagsnummer",
        city: "Stad",
        postNumber: "Postnummer",
        active: "Aktiva"
      },
      validation: {
        firstName: "Förnamnet är obligatoriskt",
        lastName: "Efternamn är obligatoriskt",
        email: "E-post är obligatoriskt",
        password: "Lösenord är obligatoriskt",
        repeatPassword: "Upprepa lösenordet är obligatoriskt",
        matchPasswords: "Lösenorden matchar inte",
        companyName: "Företagsnamn är obligatoriskt",
        companyNumber: "Företagsnummer är obligatoriskt",
        city: "Stad är obligatoriskt",
        postNumber: "Postnummer är obligatoriskt",
        validateZipCode: "Måste vara en giltig postnummer",
        validateCompanyNumber:
          "Måste vara ett giltigt företagsnummer (med eller utan () och /)"
      }
    },
    regions: {
      name: "Områden",
      titleEdit: "Område",
      titleCreate: "Skapa område",
      fields: {
        name: "Områdenamn"
      },
      inputs: {
        name: "Områdenamn"
      }
    },
    stores: {
      name: "Butiker",
      titleEdit: "Butik",
      titleCreate: "Skapa butik",
      titleTab1: "Generell information",
      titleTab2: "Webinformation",
      titleTab3: "Tilldelade kampanjer",
      titleTab4: "Extra",
      search: "Sök butik",
      fields: {
        storeName: "Butiksnamn",
        sender: "SMS-avsändare",
        storeOwner: "butiksägarna",
        activePromos: "Tilldelade aktiva kampanjer",
        email: "e-post",
        phone: "Telefon",
        deviceSerialNumber: "Enhets serienummer",
        active: "aktiva",
        region: "Område",
      },
      inputs: {
        storeOwner: "Butiksägarna",
        storeName: "Butiksnamn",
        region: "Område",
        sender: "SMS-avsändare",
        phoneNumber: "Telefonnummer",
        email: "E-post",
        deviceSerialNumber: "Enhets serienummer",
        active: "Aktiva",
        giftcard: "Gift card",
        hasQuestionnaire: "Visa frågeformuläret",
        promos: "Kampanjer",
        storeUrlText: "Butik URL-text",
        shortUrl: "Länk",
        customerNumber: "Kundnummer",
        headline: "Butiksrubrik",
        about: "Om butik",
        workingHours: {
          header: "Öppettider",
          regular: {
            days: "måndag-fredag",
            start: "öppningstid",
            end: "stängningstid"
          },
          other: {
            saturday: "lördag",
            sunday: "söndag",
            start: "öppningstid",
            end: "stängningstid"
          },
          holiday_differ: "Avvikande öppettider kan förekomma"
        },
        facebookPage: "Facebook-webbadressen (https://www.facebook.com/butik)",
        address: "Adress",
        lng: "Longitud",
        lat: "Latitud",
        placeSearch: "Sök",
        loading: "Läser in...",
        marketingPartner: {
          william_hill: {
            name: "William Hill",
            pid: "PID"
          },
          mrGreen: {
            name: "Mr Green",
            marketingSourceId: "Marknadsföringskälla-ID"
          },
          cashbacker: {
            name: "Cashbacker"
          },
          storemarket: {
            name: "Storemarket"
          },
          betfair: {
            name: "Betfair",
            pid: "PID"
          }
        }
      },
      validation: {
        storeOwner: "Butiksägaren är obligatorisk",
        storeName: "Butiksnamn är obligatoriskt",
        sender: "SMS-avsändare är obligatoriskt",
        senderASCII: "Tecken som inte stöds",
        senderCharacter: "Måste vara minst ett tecken",
        email: "E-post är obligatoriskt",
        phone: "Telefonnummer är obligatoriskt",
        requiredStoreUrl: "Butikens URL är obligatoriskt",
        storeUrlPattern: "Felmönster",
        customerNumberFormat: "Fel kundnummer format",
        headline: "Butiksrubrik är obligatoriskt",
        about: "Om butik är obligatoriskt",
        workingHours: {
          regular: {
            start: "Öppettider - startar är obligatoriskt",
            end: "Öppettider - avslutas är obligatoriskt"
          },
          other: {
            start: "Öppettider - startar är obligatoriskt",
            end: "Öppettider - avslutas är obligatoriskt"
          }
        },
        address: "Adress är obligatoriskt"
      }
    },
    marketingPartners: {
      name: "Marknadspartners",
      titleEdit: "Marknadsföringspartner",
      titleTabFeatures: "Funktioner",
      titleTabWebStyle: "Webbstil",
      fields: {
        name: "Namn",
        features: {
          integration: "Integration",
          signup_sms: "Registrera sms",
          signup_url: "Registreringsadress",
          affiliate_links: "Affiliate-länkar",
          gift_card: "Presentkorts",
        },
        createdAt: "Skapad vid"
      },
      inputs: {
        webOfferStyle: {
          logo: "Logo bild (%{dimensions})",
          backgroundColor: "Bakgrundsfärg",
          textColor: "Text färg"
        }
      },
      validation: {
        requiredBackgroundColor: "Bakgrundsfärg måste anges!",
        requiredTextColor: "Text färg måste anges!"
      }
    },
    customers: {
      name: "Kunder",
      titleEdit: "Kund",
      search: "Sök kund efter förnamn",
      filter_last_name: "Sök kund efter efternamn",
      fields: {
        storeName: "Butiksnamn",
        customer: "Kund",
        email: "E-post",
        phone: "Telefon",
        createdAt: "Skapad vid",
        updatedAt: "Uppdaterad vid",
        active: "Aktiva"
      },
      inputs: {
        storeName: "Butiksnamn",
        firstName: "Förnamn",
        lastName: "Efternamn",
        email: "E-post",
        phoneNumber: "Telefonnummer",
        active: "Aktiva"
      },
      validation: {
        storeName: "Butiken är obligatorisk",
        firstName: "Förnamnet är obligatoriskt",
        lastName: "Efternamn är obligatoriskt",
        contact: "E-post eller telefonnummer är obligatoriskt",
        phone: "Telefonnumret är ogiltigt"
      }
    },
    suppressions: {
      name: "Undertryckande",
      titleEdit: "Kund",
      search: "Sök kund efter förnamn",
      filter_last_name: "Sök kund efter efternamn",
      fields: {
        storeName: "Butiksnamn",
        customer: "Kund",
        email: "E-post",
        phone: "Telefon",
        createdAt: "Skapad vid",
        updatedAt: "Uppdaterad vid",
        active: "Aktiva"
      },
      inputs: {
        storeName: "Butiksnamn",
        firstName: "Förnamn",
        lastName: "Efternamn",
        email: "E-post",
        phoneNumber: "Telefonnummer",
        active: "Aktiva",
        uploadEmailList: "Ladda upp e-postlista",
        uploadPhoneList: "Ladda upp telefonlista",
        uploadButton: "Ladda upp"
      },
      validation: {
        storeName: "Butiken är obligatorisk",
        firstName: "Förnamnet är obligatoriskt",
        lastName: "Efternamn är obligatoriskt",
        contact: "E-post eller telefonnummer är obligatoriskt",
        phone: "Telefonnumret är ogiltigt"
      }
    },
    gametips: {
      name: "Speltips",
      titleEdit: "Speltip",
      titleCreate: "Create speltip",
      search: "Sök titel",
      fields: {
        title: "titel",
        author: "författare",
        date: "datum",
        published: "Publicerat"
      },
      inputs: {
        articleImage: "Artikelbild",
        title: "Titel",
        author: "Författare",
        date: "Datum",
        published: "Publicera?"
      },
      validation: {
        images: "Bilden är obligatorisk",
        title: "Titeln är obligatorisk",
        author: "Författaren är obligatorisk",
        date: "Datumet är obligatoriskt",
        content: "Innehållet är obligatoriskt"
      }
    },
    virtualSlips: {
      name: "Virtuella slipsar",
      titleEdit: "Virtuell slip",
      titleCreate: "Skapa virtuell slip",
      search: "Sök butik",
      fields: {
        storeName: "Butiksnamn",
        expert: "Spelläggare",
        betType: "Speltyp",
        startDate: "Omgång startar",
        sharegameSize: "Systemstorlek",
        shares: "Andelar",
        currency: "kr",
        shareCost: "Kostnad per andel",
        totalCost: "Kostnad totalt",
        closingTime: "Sista köp",
        link: "Länk",
        createdAt: "Skapad vid",
        published_at: "Publicerad på"
      },
      inputs: {
        storeName: "Butiksnamn",
        expert: "Spelläggare",
        betType: "Speltyp",
        startDate: "Omgång startar",
        sharegameSize: "Systemstorlek",
        shares: "Andelar",
        shareCost: "Kostnad per andel",
        agentCharge: "Ombudsavgift",
        totalCost: "Kostnad totalt",
        betClosingTime: "Sista köp",
        closingDate: "Spelet stängs",
        closingTime: "Tid (timmar, minuter)",
        date: "Datum",
        hours: "Timmar"
      },
      validation: {
        requiredBetType: "Bet type måste anges",
        requiredStoreName: "Butiksnamn måste anges",
        requiredExpert: "Spelläggare måste anges",
        requiredStartDate: "Datumet måste anges",
        requiredClosingTime: "Sluttiden måste anges",
        requiredShareCost: "Priset per aktie måste anges",
        requiredTotalCost: "Det totala priset måste anges",
        requiredValidNumberFormat: "Ogiltigt nummerformat",
        requiredAgentCharge: "Ombudsavgift måste anges",
        requiredShareNumber: "Andelar måste anges",
        requiredAtLestOne: "Minst ett satsningspar är nödvändigt",
        requiredField: "nödvändig",
        requiredBINLength: "måste vara 3 siffror långt"
      }
    },
    promos: {
      name: "Promos",
      titleEdit: "Promo",
      titleCreate: "Skapa promo",
      titleTab1: "Generell information",
      titleTab2: "Tilldelade butiker",
      titleTab4: "Extra",
      search: "Sök promo",
      selectToSeeExtraTab: "Välj promopartner för att kunna se denna flik",
      fields: {
        promoName: "Promo namn",
        validFrom: "Giltig från",
        validTo: "Giltig till",
        industry: "Industri",
        marketingPartner: "Marknadsföringspartner",
        assignedStoresCount: "Antal tilldelade butiker",
        active: "Aktiva",
        promoText: "Promo text",
        description: "Beskrivning",
        tosText: "Användarvillkor",
        externalLink: "Extern länk",
        backgroundImage: "Bakgrundsbild",
        image: "Promobild (%{dimensions})",
        smallImage: "Liten promo bild (%{dimensions})",
        displayLocation: "Denna kampanj vill visas:"
      },
      inputs: {
        promoName: "Promo namn",
        validFrom: "Giltig från",
        validTo: "Giltig till",
        industry: "Industri",
        marketingPartner: "Marknadsföringspartner",
        category: {
          label: "Kategori",
          choices: {
            sports: 'Sporter',
            casino: 'Kasino',
          }
        },
        activate: "Aktivera",
        giftcard: "Gift card",
        deactivate: "Avaktivera",
        promoText: "Promo text",
        title: "Titel",
        description: "Text",
        image: "Promobild (%{dimensions})",
        smallImage: "Liten promo bild (%{dimensions})",
        stores: "Butiker",
        tosText: "Användarvillkor",
        externalLink: "Extern länk",
        localPageText: "Erbjudande text",
        voucherCode: "Rabattkod",
        voucherCodeGenerate: "Generera",
        displayLocation: {
          label: "Visa den här kampanjen:",
          inputBefore: "före dataingången",
          inputAfter: "efter datainmatning"
        },
        displayOnTablet: "Visa på tablett",
        displayOnWeb: "Visa på webben",
        smsFromDefault: "Betmarket",
        smsTextDefault: `Hej, välkommen till {{.Store.Name}}  kundklubb.\n\nUnder fotbolls-VM kommer du få de bästa matchtipsen och analyserna samt mina personliga andelsspel direkt i mobilen.\n\nVi hörs den 14 juni när VM börjar.\nHa det bra.`,
        marketingPartnerTab: {
          william_hill: {
            name: "William Hill",
            bid: "BID"
          },
          mrGreen: {
            name: "Mr Green",
            lpid: "LPID",
            bid: "BID"
          },
          cashbacker: {
            name: "Cashbacker",
            campaign_id: "Campaign ID"
          },
          storemarket: {
            name: "Storemarket"
          },
          betfair: {
            name: "Betfair",
            bid: "BID"
          }
        }
      },
      validation: {
        requiredPromoName: "The promotion name is required",
        requiredValidFrom: "The valid from date is required",
        requiredValidTo: "The valid to date is required",
        requiredIndustry: "The industry is required",
        requiredMarketingPartnerName: "The marketing partner name is required",
        requiredDescription: "The description is required",
        requiredImage: "Bilden är nödvändig",
        requiredImageDimensions: {
          large: "Bilddimensionerna måste vara %{dimensions}.",
          small: "Bilddimensionerna måste vara %{dimensions}.",
          current: "(Mått på aktuell bild: "
        },
        requiredTosText: "The terms of service are required",
        requiredVoucherCodeLength: "måste vara 10 siffror långt",
        requiredVoucherCodeUppercase: "måste vara alla stora versioner",
        requiredBothIDFields: "båda ID-fälten måste vara antingen tomma eller fyllda"
      }
    },
    activation: {
      name: "Aktiveringssida",
      description: "Fråga kunden om den vill ha någon av dina senaste kampanjer från Cashbacker och samtidigt bli medlem i din kundklubb. Om den säger ”ja tack” fyll i nedan fält och välj kampanj.",
      fields: {
        phone: "Telefonnummer",
        email: "E-post",
        check: "Kolla Kunden",
        add: "Lägg till ny kund",
        update: "Registrera",
        reset: "Lägg till ny +",
        addCampaign: "SKICKA KAMPANJ TILL DIN KUND"
      },
      titleCreate: "Skapa ny",
      customerAdded: "Kunden är registrerad!",
      customerAddError: "Kundanpassningen misslyckades",
      customerNotFound: "Kunden hittades inte, vänlig skriv in e-postadress för att skapa en ny medlem.",
      customerUpdated: "Kund uppdaterad",
      customerUpdateError: "Kundanpassningen misslyckades",
      campaignAdded: "Kampanjen är sänd!",
      campaignAddFailed: "Kampanjen misslyckades",
      steps: {
        "title": "Instruktion – så gör du!",
        "1":"Skriv in kundens mobiltelefonnummer",
        "2":"Skriv in kundens e-post adress",
        "3":"Välj den kampanj kunden önskar",
        "4":"Skicka kampanjen genom att trycka på ”skicka”",
        "5":"Inom kort kommer din kund få ett SMS med kampanjen och allmänna användarvillkor. När kunden klickar på SMSets bifogade länk skickas kunden till vald/skickad kampanj. Samtidigt får han/hon ett konto på Cashbacker.se.",
      }
    },
    messageTemplates: {
      name: "Meddelandemallar",
      titleEdit: "Meddelande mall",
      fields: {
        name: "Namn"
      },
      inputs: {
        name: "Namn",
        description: "Beskrivning",
        smsContent: "SMS-innehåll"
      }
    },
    storeMessages: {
      name: "Butik meddelanden",
      titleEdit: "Butik meddelande",
      deletedStore: "Raderad butik",
      fields: {
        storeName: "Butiksnamn",
        smsFrom: "SMS från",
        emailFrom: "E-post från",
        emailSubject: "E-post ämne",
        sentAt: "Skickad på",
        emailPlainText: "E-post oformatterad text",
        emailHtmlText: "E-post HTML text",
        smsText: "SMS text",
        dialogBox: {
          confirmMessage: "Är du säker?",
          warningMessage: "Detta kan inte göras ogjort.",
          confirmButton: "Jag är säker!",
          cancelButton: "Annullera"
        }
      },
      inputs: {
        emailPlainText: "E-post oformatterad text",
        emailHtmlText: "E-post HTML text",
        smsText: "SMS text",
        emailFrom: "E-post från",
        emailSubject: "E-post ämne",
        contentPlainText: "Innehåll oformatterad text",
        contentHtml: "Innehåll HTML",
        smsFrom: "SMS från"
      },
      validation: {
        smsFrom: "Message sender is required",
        smsText: "Message text is required",
        emailFrom: "E-mail sender is required",
        emailText: "E-mail text is required",
        emailSubject: "E-mail subject is required",
        plainText: "Plain text is required",
        emailHtml: "E-mail HTML is required"
      }
    },
    welcomeMessage: {
      name: "Välkomstmeddelande",
      fields: {
        emailPlainText: "E-post oformatterad text",
        emailHtmlText: "E-post HTML text",
        smsText: "SMS text",
        emailFrom: "E-post från",
        emailSubject: "E-post ämne",
        contentPlainText: "Innehåll oformatterad text",
        contentHtml: "Innehåll HTML",
        smsFrom: "SMS från"
      },
      inputs: {
        emailPlainText: "E-post oformatterad text",
        emailHtmlText: "E-post HTML text",
        smsText: "SMS text",
        emailFrom: "E-post från",
        emailSubject: "E-post ämne",
        contentPlainText: "Innehåll oformatterad text",
        contentHtml: "Innehåll HTML",
        smsFrom: "SMS från"
      },
      validation: {
        email: "E-post är obligatoriskt",
        name: "Namnet är obligatoriskt",
        smsText: "SMS text är obligatoriskt"
      }
    },
    devices: {
      name: "Enheter",
      titleEdit: "Enhet",
      reportsTable: "Rapporter",
      fields: {
        storeName: "Butiksnamn",
        deviceSerialNumber: "Enhets serienummer",
        lastReport: "Senaste rapporten",
        timestamp: "Skapad vid",
        uptime: "Upp tid",
        unknownUptime: "Okänd upptid",
        wifiConnectionName: "WiFi-anslutningsnamn",
        application_version: "Application version"
      },
      inputs: {
        storeName: "Butiksnamn"
      }
    },
    reports: {
      mainReportsPageTitle: "Rapport",
      customerReportsTitle: "Kundanalysrapport",
      giftCardsReportsTitle: "Analysrapport för presentkort",
      customerPhonesReportsTitle: "Rapport telefonnummer",
      customerEmailsReportsTitle: "Rapport e-post",
      cashbackerCampaignRegistrationsReportsTitle: "Rapport cashbacker",     
      name: "Rapporter",
      titleEdit: "Rapporter",
      reportsTable: "Rapporter",
      // fields: {
      //   storeName: "Butiksnamn",
      //   deviceSerialNumber: "Enhets serienummer",
      //   lastReport: "Senaste rapporten",
      //   timestamp: "Skapad vid",
      //   uptime: "Upp tid",
      //   wifiConnectionName: "WiFi-anslutningsnamn"
      // },
      dateFrom: "Datum från",
      dateTo: "Datum till",
      exportAction: "Exportera",
      chooseBothDates: "Välj datum från och till"
    },
    giftCards: {
      name: "Presentkort",
      create: "Lägg till ny",
      editGiftCard: "Present Kort",
      createGiftCard: "Skapa Presentkort",
      customer: "Kund",
      activateButton: "Aktivera Presentkort",
      saveButton: "Spara",
      customerCreateError: "Kundanpassningen misslyckades",
      checkCustomerButton: "Kolla Kunden",
      customerNotChecked: "Du har inte kontrollerat kund!",
      promosLabel: "Kampanjer",
      valuesLabel: "Värden"
    },
    noPermissiom: {
      text: "Sorry, only ADMIN can see this"
    },
    interpolations: {
      instructions: `Mallar stöder interpolering av värden, så att de förs in dynamiskt baserat på butik, kund och marknadsföring.
      Observera att interpoleringen måste användas exakt - inuti dubbla klammers {{ }} och mellanslag, med rätt ordföljd och börja med en punkt.`,
      supported: "Stödad interpolering:"
    }
  },

  // missing aor translations for Swedish:
  aor: {
    action: {
      delete: "Radera",
      show: "Visa",
      list: "Lista",
      save: "Spara",
      create: "Skapa",
      edit: "Redigera",
      cancel: "Avbryt",
      refresh: "Ladda om",
      send: "Skicka",
      add_filter: "Lägg till filter",
      remove_filter: "Ta bort filter",
      back: "Gå tillbaka"
    },
    boolean: {
      true: "Ja",
      false: "Nej"
    },
    page: {
      list: "%{name} Lista",
      edit: "%{name} #%{id}",
      show: "%{name} #%{id}",
      create: "Skapa %{name}",
      delete: "Radera %{name} #%{id}",
      dashboard: "Överblick",
      not_found: "Hittades inte"
    },
    input: {
      image: {
        upload_several:
          "Drag och släpp filer för att ladda upp, eller klicka för att välja filer.",
        upload_single:
          "Drag och släpp en fil för att ladda upp, eller klicka för att välja fil"
      },
      autocomplete: {
        none: "Ingen"
      },
      references: {
        many_missing: "Doesn't exist",
        single_missing: "Doesn't exist"
      }
    },
    message: {
      yes: "Ja",
      no: "Nej",
      are_you_sure: "Är du säker?",
      about: "Om",
      not_found: "Hittades inte"
    },
    navigation: {
      no_results: "Inga resultat hittades",
      page_out_of_boundaries: "Sidnummer %{page} utanför spannet",
      page_out_from_end: "Kan inte besöka sida efter sista sidan",
      page_out_from_begin: "Kan inte besöka sida före första sidan",
      page_range_info: "%{offsetBegin}-%{offsetEnd} av %{total}",
      next: "Nästa",
      prev: "Föregående",
      no_more_results: "Inga resultat på denna sida"
    },
    auth: {
      username: "Användarnamn",
      password: "Lösenord",
      sign_in: "Logga in",
      sign_in_error: "Inloggning misslyckades, försök gärna igen",
      logout: "Logga ut"
    },
    notification: {
      updated: "Objekt uppdaterat",
      created: "Objekt skapat",
      deleted: "Objekt raderat",
      bulk_deleted: "Objekt raderas",
      sent: "Objektet skickades framgångsrikt",
      item_doesnt_exist: "Objektet hittas inte",
      http_error: "Kommunikationsfel med servern"
    },
    validation: {
      required: "Obligatorisk",
      minLength: "Måste vara minst %{min} tecken",
      maxLength: "Måste vara max %{max} tecken",
      minValue: "Måste vara minst %{min}",
      maxValue: "Måste vara max %{max}",
      number: "Måste vara ett nummer number",
      email: "Måste vara en giltig e-postadress"
    }
  },

  // error messages
  ERROR_READING_IMAGE_DATA: "Kan inte läsa av bilden, försök igen - Fel 2001",
  ERROR_CONSTRUCTING_OCR_REQUEST:
    "Kan inte läsa av bilden, försök igen - Fel 2002",
  ERROR_CONTACTING_OCR_SERVICE:
    "Kan inte läsa av bilden, försök igen - Fel 2003",
  ERROR_READING_OCR_RESPONSE: "Kan inte läsa av bilden, försök igen - Fel 2004",
  ERROR_PROCESSING_OCR_RESPONSE:
    "Kan inte läsa av bilden, försök igen - Fel 2005",
  ERROR_STORING_SLIP_RECORD: "Kan inte spara skannad slip - Fel 2006",
  ERROR_CONSTRUCTING_OCR_RESPONSE: "Oj, något gick fel - Fel 2007",
  SLIP_NOT_FOUND: "Hittar inte skannad slip - Fel 2008",
  ERROR_FETCHING_SLIP_RECORD: "Kan inte läsa av skannad slip - Fel 2009",
  ERROR_CONSTRUCTING_SLIP_RESPONSE: "Oj, något gick fel - Fel 2010",
  ERROR_READING_SLIP_DATA: "Kan inte spara skannad slip - Fel 2011",
  ERROR_PROCESSING_SLIP_DATA: "Kan inte spara skannad slip - Fel 2012",
  SLIP_UPDATE_NOT_FOUND: "Hittar inte skannad slip - Fel 2013",
  ERROR_PROCESSING_SLIP_RECORD: "Kan inte spara skannad slip - Fel 2014",
  ERROR_UPDATING_SLIP_RECORD: "Kan inte spara skannad slip - Fel 2015",
  ERROR_CONSTRUCTING_UPDATE_RESPONSE: "Oj, något gick fel - Fel 2016",
  ERROR_GENERATING_NOTIFICATIONS: "Kan inte skapa notifieringar - Fel 2017",
  ERROR_SENDING_NOTIFICATIONS: "Kan inte skicka notifieringar - Fel 2018",
  ERROR_DECODING_SLIP_UUID: "Hittar inte skannad slip - Fel 2019",
  ERROR_CONVERTING_SLIP_UUID: "Hittar inte skannad slip - Fel 2020"
};

export default messages;



// WEBPACK FOOTER //
// ./src/i18n/sv.js